import "./EcardCtaButton.css";
import { cn } from "../lib/utils";

interface EcardCtaButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
}

const EcardCtaButton: React.FC<EcardCtaButtonProps> = ({
  children,
  className,
  ...props
}) => {
  return (
    <button type="button" className={cn("ecard-cta-glow", className)} {...props}>
      <span className="ecard-cta-glow__label">{children}</span>
    </button>
  );
};

export default EcardCtaButton;
